// config.js
import { getCookie } from "../shared/utils";

const awsEnv = getCookie("awsenv");

const ENV_CONFIG = {
  local: {
    production: false,
    staging: false,
    pwa: false, 
    auth_domain: '.localhost',
    auth_token: 'sodisys_token',
    device_id:'sodisys_di',

    api_url: 'http://localhost:8000/public/',
    sys_api_url:'http://localhost:4100/',
    simpler_api_url:'http://localhost:4101/',
    public_url: 'http://localhost:4201/a',
    asset_api_url: 'http://localhost:4104/',
    socket_api_url:"http://localhost:4107/",
          
    shift_api_url:'http://localhost:4105/',
    // api_url: 'http://localhost:8000/',
    // public_url: 'http://localhost:4201/a',
    // asset_api_url: 'http://localhost:4104/',

    app_url: 'http://localhost:4200',
    form_url: 'http://localhost:4200',
    auth_url: 'http://localhost:4201',
    firebase: {
      apiKey: "AIzaSyDcFLgC4O2paUlr_pcrC29B1Bkk1kk7QPc",
      authDomain: "sodisys-live.firebaseapp.com",
      projectId: "sodisys-live",
      storageBucket: "sodisys-live.appspot.com",
      messagingSenderId: "788516771470",
      appId: "1:788516771470:web:e4d800c2b009de7d755bdf"
    },
    fcm_push_certificate: 'BAS9RlYk_PdfbX5m0CBkQm70gNLtkn4aB9gb-twqH0STOF6KfWro4Y912EC2GL7OdY2gMF1yXjKgV27yqN-gHYo',
  },
  development:{
    production: false,
    staging: false,
    pwa: true,
    auth_domain: '.sodisys.net',
    auth_token: 'token',
    device_id: 'dev_di',

    api_url: 'https://dev-api.sodisys.net/ci-api/public/',
    sys_api_url: 'https://dev-sysapi.sodisys.net/',
    simpler_api_url: 'https://dev-simplerapi.sodisys.net/',
    shift_api_url: 'https://dev-shiftapi.sodisys.net/',
    public_url: 'https://dev-public.sodisys.net/a',
    asset_api_url: 'https://dev-asset.sodisys.net',

    app_url: 'https://dev.sodisys.net',
    form_url: 'https://dev-api.sodisys.net/assets/sodisysForm.js',
    firebase: {
        apiKey: "AIzaSyCyDbZTWFuTIgx0yTHPIf6vz33qBkIg1iw",
        authDomain: "staging-sodisys.firebaseapp.com",
        projectId: "staging-sodisys",
        storageBucket: "staging-sodisys.appspot.com",
        messagingSenderId: "488146236863",
        appId: "1:488146236863:web:05e0b719fb5183eabb5d0a"
    },
    fcm_push_certificate: 'BK4jxODWfQeRa_YFJtnYRMinCM8V_faosbFdoLkBrDkrEFQ5Bkc8UU2lo04-jYM-2h49fWJTbu0PMg2h-JIQcTM',
  },
  staging_aws: {
    production: false,
    staging: true,
    pwa: true,
    auth_domain: '.sds-a.ws',
    auth_token: 'aws_staging_token',
    device_id:'aws_staging_di',

    api_url: 'https://app-api.sds-a.ws/',
    sys_api_url: 'https://sysapi.sds-a.ws/',
    simpler_api_url: '',
    shift_api_url: 'https://shift-api.stg.sodisys.net/',
    public_url: 'https://staging-public.sodisys.net/a',
    asset_api_url: 'https://asset-api.sds-a.ws/',
    socket_api_url: "https://socket.stg.sodisys.net/",
    app_url: 'https://app.sds-a.ws',
    shift_app_url: 'https://shift.sds-a.ws/',
    auth_url: 'https://auth.sds-a.ws',
    form_url: 'https://staging-api.sodisys.net/assets/sodisysForm.js',
    firebase: {
      apiKey: "AIzaSyDcFLgC4O2paUlr_pcrC29B1Bkk1kk7QPc",
      authDomain: "sodisys-live.firebaseapp.com",
      projectId: "sodisys-live",
      storageBucket: "sodisys-live.appspot.com",
      messagingSenderId: "788516771470",
      appId: "1:788516771470:web:e4d800c2b009de7d755bdf"
    },
    fcm_push_certificate: 'BAS9RlYk_PdfbX5m0CBkQm70gNLtkn4aB9gb-twqH0STOF6KfWro4Y912EC2GL7OdY2gMF1yXjKgV27yqN-gHYo',
  },
  staging: {
    production: false,
    staging: true,
    pwa: true,
    auth_domain: '.staging.net',
    auth_token: 'sodisys_token',
    device_id:'staging_di',

    api_url: 'https://appapi.stg.sodisys.net/public/',
    sys_api_url: 'https://staging-sysapi-new.sodisys.net/',
    simpler_api_url: 'https://staging-simplerapi.sodisys.net/',
    shift_api_url: 'https://shift-api.stg.sodisys.net/',
    public_url: 'https://staging-public.sodisys.net/a',
    asset_api_url: 'https://staging-asset.sodisys.net/',
    socket_api_url: "https://socket.stg.sodisys.net/",

    app_url: 'https://staging.sodisys.net',
    auth_url: 'https://staging-auth.sodisys.net',
    form_url: 'https://staging-api.sodisys.net/assets/sodisysForm.js',
    firebase: {
      apiKey: "AIzaSyDcFLgC4O2paUlr_pcrC29B1Bkk1kk7QPc",
      authDomain: "sodisys-live.firebaseapp.com",
      projectId: "sodisys-live",
      storageBucket: "sodisys-live.appspot.com",
      messagingSenderId: "788516771470",
      appId: "1:788516771470:web:e4d800c2b009de7d755bdf"
    },
    fcm_push_certificate: 'BAS9RlYk_PdfbX5m0CBkQm70gNLtkn4aB9gb-twqH0STOF6KfWro4Y912EC2GL7OdY2gMF1yXjKgV27yqN-gHYo',

  },
  production: {
    production: true,
    staging: false,
    pwa: true,
    auth_domain: '.sodisys.net',
    auth_token: 'token',
    device_id:'sodisys_di',

    api_url:  'https://appapi.app.sodisys.eu/public' ,
    sys_api_url:  'https://sysapi-aws.app.sodisys.eu',
    simpler_api_url: 'https://simplerapi.sodisys.net/',
    shift_api_url:  'https://shiftapi.app.sodisys.eu/',
    public_url: 'https://public.sodisys.net/a',
    asset_api_url:  'https://asset-aws.app.sodisys.eu/' ,
    socket_api_url:"https://socket.app.sodisys.eu/",


    app_url: 'https://app.sodisys.net',
    auth_url: 'https://auth.sodisys.net',
    form_url: 'https://app-api.sodisys.net/assets/sodisysForm.js',

    firebase: {
      apiKey: "AIzaSyDcFLgC4O2paUlr_pcrC29B1Bkk1kk7QPc",
      authDomain: "sodisys-live.firebaseapp.com",
      projectId: "sodisys-live",
      storageBucket: "sodisys-live.appspot.com",
      messagingSenderId: "788516771470",
      appId: "1:788516771470:web:e4d800c2b009de7d755bdf"
    },
    fcm_push_certificate: 'BAS9RlYk_PdfbX5m0CBkQm70gNLtkn4aB9gb-twqH0STOF6KfWro4Y912EC2GL7OdY2gMF1yXjKgV27yqN-gHYo',
  },
  stagingLocal: {
    production: false,
    staging: true,
    pwa: true,
    auth_domain: '.localhost',
    auth_token: 'sodisys_token',
    device_id:'staging_di',

    api_url: 'https://appapi.stg.sodisys.net/public/',
    sys_api_url: 'https://staging-sysapi-new.sodisys.net/',
    simpler_api_url: 'https://staging-simplerapi.sodisys.net/',
    shift_api_url: 'https://shift-api.stg.sodisys.net/',
    public_url: 'https://staging-public.sodisys.net/a',
    asset_api_url: 'https://staging-asset.sodisys.net/',
    socket_api_url: "https://socket.stg.sodisys.net/",

    app_url: 'https://staging.sodisys.net',
    auth_url: 'https://staging-auth.sodisys.net',
    form_url: 'https://staging-api.sodisys.net/assets/sodisysForm.js',
    firebase: {
      apiKey: "AIzaSyDcFLgC4O2paUlr_pcrC29B1Bkk1kk7QPc",
      authDomain: "sodisys-live.firebaseapp.com",
      projectId: "sodisys-live",
      storageBucket: "sodisys-live.appspot.com",
      messagingSenderId: "788516771470",
      appId: "1:788516771470:web:e4d800c2b009de7d755bdf"
    },
    fcm_push_certificate: 'BAS9RlYk_PdfbX5m0CBkQm70gNLtkn4aB9gb-twqH0STOF6KfWro4Y912EC2GL7OdY2gMF1yXjKgV27yqN-gHYo',

  },
  prodLocal: {
    production: true,
    staging: false,
    pwa: true,
    awsEnv: 'awsenv',
    auth_domain: '.localhost',
    auth_token: 'sodisys_token',
    device_id:'sodisys_di',

    api_url: 'https://appapi.app.sodisys.eu/public/',
    sys_api_url: 'https://sysapi-aws.app.sodisys.eu/',
    simpler_api_url: 'https://simplerapi.sodisys.net/',
    shift_api_url: 'https://shiftapi.app.sodisys.eu/',
    public_url: 'https://public.sodisys.net/a',
    asset_api_url: 'https://asset-aws.app.sodisys.eu/',
    socket_api_url:"https://socket.app.sodisys.eu/",


    app_url: 'https://app.sodisys.net',
    auth_url: 'https://auth.sodisys.net',
    form_url: 'https://app-api.sodisys.net/assets/sodisysForm.js',
    firebase: {
      apiKey: "AIzaSyDcFLgC4O2paUlr_pcrC29B1Bkk1kk7QPc",
      authDomain: "sodisys-live.firebaseapp.com",
      projectId: "sodisys-live",
      storageBucket: "sodisys-live.appspot.com",
      messagingSenderId: "788516771470",
      appId: "1:788516771470:web:e4d800c2b009de7d755bdf"
    },

    fcm_push_certificate: 'BAS9RlYk_PdfbX5m0CBkQm70gNLtkn4aB9gb-twqH0STOF6KfWro4Y912EC2GL7OdY2gMF1yXjKgV27yqN-gHYo',
  },
};
const environment = process.env.REACT_APP_ENV || 'local';
const config = ENV_CONFIG[environment]

export default config;
